
riot.tag2('treeview', '  <loader if="{opts.loader}"></loader>\n  <treenodes if="{!opts.loader}" nodes="{nodes}" handlers="{opts.handlers}" treeview="{this}" label-field="{labelField}" children-field="{childrenField}" dblclick="{opts.dblclick}">\n    <yield to="before">\n      <yield from="before"></yield>\n    </yield>\n    <yield to="after">\n      <yield from="after"></yield>\n    </yield>\n  </treenodes>\n', '', '', function(opts) {
'use strict';

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.nodes = [];
self.labelField = opts.labelField || 'label';
self.childrenField = opts.childrenField || 'children';
self.descendants = opts.descendants || undefined;

self.toggleChildren = function (node, value) {
    if (node[self.childrenField] && node[self.childrenField] instanceof Array) {
        node[self.childrenField].forEach(function (item) {
            item.__selected__ = value;
            self.toggleChildren(item, value);
        });
    }
};

self.toggleParent = function (item) {
    if (item.__parent__) {
        var parent = item.__parent__;
        if (parent instanceof Object && !(parent instanceof Array)) {
            var selected = parent[self.childrenField].map(function (i) {
                return i.__selected__;
            }).indexOf(false) <= -1;
            parent.__selected__ = selected;
            self.toggleParent(parent);
        }
    }
};

self.deselectAll = function () {
    var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.nodes;

    if (nodes instanceof Array) {
        nodes.forEach(function (item) {
            item.__selected__ = false;
            if (item[self.childrenField]) self.deselectAll(item[self.childrenField]);
        });
    }
};

/** Выделить все
 * Запускает рекурсивную функцию для выделения элементов всех уровней
 *
 * @param array nodes  нумерованный массив с информацией об элементах
 */
self.selectAllRows = function () {
    var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.nodes;

    selectAllRowsChildren(nodes);
};

/** Исключить из списка
 *
 * @param array nodes  нумерованный массив с информацией об элементах
 * @param str exception id редактируемой группы для исключения из списка
 */
self.exceptionFilter = function (nodes, exception) {
    exceptionFilter(nodes, exception);
};

self.getSelectedNodes = function () {
    var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.nodes;

    var result = [];

    if (nodes instanceof Array) {
        nodes.forEach(function (item) {
            if (item.__selected__) result.push(item);
            if (item[self.childrenField]) {
                var childResult = self.getSelectedNodes(item[self.childrenField]);
                result = [].concat(result, childResult);
            }
        });
        return result;
    }
    return [];
};

self.removeNodes = function () {
    var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.nodes;

    var result = [];
    if (nodes instanceof Array) {
        nodes.forEach(function (item) {
            if (item.__selected__) {
                nodes.splice(nodes.indexOf(item), 1);
                self.removeNodes(nodes);
                return;
            }
            if (item[self.childrenField]) {
                self.removeNodes(item[self.childrenField]);
            }
        });
    }
};

/** Рекурсивная функция выделения всех строк в древовидном списке (включая детей)
 *
 * @param array nodes  нумерованный массив с информацией об элементах
 * @var array item["childs"] нумерованный массив с информацией о Дочерних элементах
 */
function selectAllRowsChildren(nodes) {
    if (nodes instanceof Array) {
        nodes.forEach(function (item) {
            if (item["childs"] && item["childs"].length > 0) {
                selectAllRowsChildren(item["childs"]);
            }
            item.__selected__ = true;
        });
    }
}

/** Рекурсия исключения из древовидного списка
 * 1 запускаем цикл прохода по уровню
 * 2 если id совпадает с исключением - удаляем из массива, заканчиваем поиск
 * 3 если исключение не сработало и есть элементы-дети - запускаем проверку уровня ниже
 * 4 если исключение встретилось в нижних уровнях и вернулось true - заканчиваем поиск
 *
 * @param array nodes  нумерованный массив с информацией об элементах
 * @param str exception id редактируемой группы для исключения из списка
 * @return bool true - исключение найденно
 */
function exceptionFilter(nodes, exception) {
    if (nodes instanceof Array) {
        // 1
        nodes.forEach(function (item, index, object) {
            if (item["id"] == exception) {
                // 2
                object.splice(index, 1);
                return true;
            }
            if (item["childs"].length > 0) {
                // 3
                var stop = exceptionFilter(item["childs"], exception);
                if (stop == true) return true; // 4
            }
        });
    }
}

function setParentLinks(nodes) {
    var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : self.nodes;

    if (nodes instanceof Array) {
        nodes.forEach(function (item) {
            Object.defineProperty(item, '__parent__', {
                writable: true,
                configurable: true,
                enumerable: false,
                value: parent
            });
            if ((typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item)) === 'object' && item[self.childrenField]) setParentLinks(item[self.childrenField], item);
        });
    }
}

self.on('update', function () {
    self.labelField = opts.labelField || 'label';
    self.childrenField = opts.childrenField || 'children';
    self.descendants = opts.descendants || undefined;

    if (self.nodes !== opts.nodes) {
        self.nodes = opts.nodes || [];
        setParentLinks(self.nodes);
    }
});
});
riot.tag2('treenodes', '  <ul each="{nodes}">\n    <li>\n      <div class="treenode{__selected__ ? &quot; selected&quot; : &quot;&quot;}" title="{title}" onclick="{select}" ondblclick="{dblclick}"><span class="icon {this[parent.childrenField].length ? expanded ? css.open  : css.closed : css.leaf}" onclick="{toggleExpand}"></span>\n        <yield from="before"></yield><span class="{this[parent.childrenField].length ? &quot;&quot; : &quot;leaf&quot;}" draggable="true" ondragstart="{handleDragStart}" ondragenter="{handleDragEnter}" ondragover="{handleDragOver}" ondragleave="{handleDragLeave}" ondrop="{handleDrop}" ondragend="{handleDragEnd}">{this[parent.labelField]}</span>\n        <yield from="after"></yield>\n      </div>\n      <hr class="drop" ondragenter="{handleDragEnterHr}" ondragleave="{handleDragLeaveHr}" ondragover="{handleDragOverHr}" ondrop="{handleDropHr}">\n      <treenodes nodes="{this[parent.childrenField]}" dblclick="{dblclick}" handler="{parent.handler}" css="{parent.css}" if="{expanded}" handlers="{handlers}" treeview="{treeview}" label-field="{labelField}" children-field="{childrenField}">\n        <yield to="before">\n          <yield from="before"></yield>\n        </yield>\n        <yield to="after">\n          <yield from="after"></yield>\n        </yield>\n      </treenodes>\n    </li>\n  </ul>\n', 'treenodes ul,[riot-tag="treenodes"] ul,[data-is="treenodes"] ul{ list-style: none; padding-left: 2em; margin: 0.25em 0; } treenodes li,[riot-tag="treenodes"] li,[data-is="treenodes"] li{ cursor: pointer; } treenodes .icon,[riot-tag="treenodes"] .icon,[data-is="treenodes"] .icon{ width: 1.1em; } treenodes .treenode.selected,[riot-tag="treenodes"] .treenode.selected,[data-is="treenodes"] .treenode.selected{ background-color: #d9edf7; } treenodes .treenode span.highlight,[riot-tag="treenodes"] .treenode span.highlight,[data-is="treenodes"] .treenode span.highlight{ border: 2px dashed #000; } treenodes hr.drop,[riot-tag="treenodes"] hr.drop,[data-is="treenodes"] hr.drop{ margin: 0; padding-top: 3px; padding-bottom: 3px; border: 0; border-top: 1px solid #fff; } treenodes hr.drop.highlight,[riot-tag="treenodes"] hr.drop.highlight,[data-is="treenodes"] hr.drop.highlight{ padding-top: 8px; padding-bottom: 8px; border-top: 2px solid #000; }', '', function(opts) {
'use strict';

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _this = this;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.treeview = opts.treeview;
self.labelField = opts.labelField || 'label';
self.childrenField = opts.childrenField || 'children';

self.nodes = opts.nodes || [];

var doubleClick = opts.dblclick || function (e) {};

self.on('update', function () {
    self.title = opts.title;
    self.css = opts.css || { open: 'fa fa-fw fa-caret-down', closed: 'fa fa-fw fa-caret-right', leaf: 'fa fa-fw' };
    self.nodes = opts.nodes || [];
    self.handlers = opts.handlers || {};
    self.labelField = opts.labelField || 'label';
    self.childrenField = opts.childrenField || 'children';
});

self.dblclick = function (e) {
    doubleClick(e);
};

self.handleDragStart = function (e) {
    e.target.style.opacity = 0.5;
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('json', (0, _stringify2.default)(e.item));
    return true;
};

self.handleDragOver = function (e) {
    //console.log("DragOver")
};

self.handleDragEnterHr = function (e) {
    e.target.classList.add('highlight');
};

self.handleDragLeaveHr = function (e) {
    e.target.classList.remove('highlight');
};

self.handleDragOverHr = function (e) {};

self.handleDragEnter = function (e) {
    if (e.fromElement) e.target.classList.add('highlight');
};

self.handleDragLeave = function (e) {
    e.target.classList.remove('highlight');
};

self.handleDrop = function (e) {
    e.target.classList.remove('highlight');
    var dataTransfer = JSON.parse(e.dataTransfer.getData("json"));
    if (dataTransfer.id == e.item.id) {
        e.stopPropagation();
        return false;
    }

    self.changeParent(self.treeview.nodes, e.item, dataTransfer.id);

    e.stopPropagation();
    return false;
};

self.handleDropHr = function (e) {
    e.target.classList.remove('highlight');
    var dataTransfer = JSON.parse(e.dataTransfer.getData("json"));
    if (dataTransfer.id == e.item.id) {
        e.stopPropagation();
        return false;
    }

    if (e.item.upid != dataTransfer.upid) {
        var itemParent = e.item.upid ? self.getItemById(self.treeview.nodes, e.item.upid) : null;
        self.changeParent(self.treeview.nodes, itemParent, dataTransfer.id);
    }

    self.changePositionItem(e.item, dataTransfer.id);

    e.stopPropagation();
    return false;
};

self.handleDragEnd = function (e) {
    e.target.style.opacity = 1;
    self.update();
};

self.toggleExpand = function (e) {
    e.stopPropagation();
    e.item.expanded = !e.item.expanded;
};

self.getItemById = function (nodes, id) {

    for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].id == id) return nodes[i];

        if (nodes[i][self.childrenField]) {
            var result = self.getItemById(nodes[i][self.childrenField], id);
            if (result) return result;
        }
    }

    return null;
};

self.changeParent = function (nodes, itemParent, id) {
    var indexDel = -1;

    nodes.forEach(function (item, i) {
        if (item.id == id) {
            indexDel = i;
            return;
        }
    });
    if (indexDel > -1) {
        var item = nodes[indexDel];
        nodes.splice(indexDel, 1);
        var idParent = null;
        var position = self.treeview.nodes.length;
        if (itemParent) {
            if (itemParent[self.childrenField].length > 0) position = itemParent[self.childrenField][itemParent[self.childrenField].length - 1].position + 1;
            itemParent[self.childrenField].push(item);
            idParent = itemParent.id;
        } else self.treeview.nodes.push(item);

        if ('afterChangeParent' in self.handlers && typeof self.handlers.afterChangeParent === 'function') self.handlers.afterChangeParent.call(_this, idParent, id, position);
    } else {
        nodes.forEach(function (item, i) {
            if (item[self.childrenField]) self.changeParent(item[self.childrenField], itemParent, id);
        });
    }
};

self.changePositionItem = function (item, id) {
    var nodes = self.getNodesWithId(self.treeview.nodes, id);
    var indexDel = -1;

    nodes.forEach(function (item, i) {
        if (item.id == id) {
            indexDel = i;
            return;
        }
    });
    if (indexDel > -1) {
        var itemMove = nodes[indexDel];
        nodes.splice(indexDel, 1);
        nodes = self.getNodesWithId(self.treeview.nodes, item.id);
        if (nodes) {
            var indexInsert = nodes.indexOf(item);
            if (indexInsert > -1) {
                (function () {
                    nodes.splice(indexInsert + 1, 0, itemMove);
                    var indexes = [];
                    nodes.forEach(function (item, sort) {
                        item.sort = sort;
                        indexes.push({ id: item.id, sort: sort });
                    });
                    if ('afterChangePosition' in self.handlers && typeof self.handlers.afterChangePosition === 'function') self.handlers.afterChangePosition.call(_this, indexes);
                })();
            }
        }
    }
};

self.getNodesWithId = function (nodes, id) {

    for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].id == id) return nodes;

        if (nodes[i][self.childrenField]) {
            var result = self.getNodesWithId(nodes[i][self.childrenField], id);
            if (result) return result;
        }
    }

    return null;
};

self.select = function (e) {
    if (e.ctrlKey) {
        e.item.__selected__ = !e.item.__selected__;
        if (self.treeview.descendants) {
            self.treeview.toggleChildren(e.item, e.item.__selected__);
            self.treeview.toggleParent(e.item);
            self.treeview.update();
        }
    } else {
        self.treeview.deselectAll();
        e.item.__selected__ = true;
        if (self.treeview.descendants) {
            self.treeview.toggleChildren(e.item, e.item.__selected__);
        }
        self.treeview.update();
    }

    var count = self.treeview.getSelectedNodes().length;
    self.treeview.trigger('nodeselect', e.item, count);
};

self.stopPropagation = function (e) {
    e.stopPropagation();
};
});


// WEBPACK FOOTER //
// ./components/treeview.tag